import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { TruncatedTooltipView, TruncatedCollapsedView } from './View/index.js';
export const Truncated = ({ view, content, maxLines = 1, children }) => {
    switch (view) {
        case 'tooltip':
            return (_jsx(TruncatedTooltipView, { maxLines: maxLines, content: content, children: styles => children(styles) }));
        case 'collapsed':
            return (_jsx(TruncatedCollapsedView, { maxLines: maxLines, children: styles => children(styles) }));
    }
};
//# sourceMappingURL=index.js.map